<span *ngIf="abonnes; else noAbonnes">{{abonnes}} {{abonnes > 1 ? 'inscrits' : 'inscrit'}}</span>
<ng-template #noAbonnes>0 inscrit</ng-template>
